import { PropsWithChildren } from 'react';
import { TopBannersLayoutStyled } from './TopBannersLayout.styled';
import { CookieConsentBanner } from '../banner/CookieConsentBanner';
import { VersionUpdateBanner } from '../banner/VersionUpdateBanner';
import { BannersWrapper } from '../banner/Banner.styled';

type Props = PropsWithChildren<{
  inPageWithSideMenu?: boolean;
}>;

export const TopBannersLayout = ({
  inPageWithSideMenu = false,
  children,
}: Props) => {
  return (
    <TopBannersLayoutStyled>
      <BannersWrapper inPageWithSideMenu={inPageWithSideMenu}>
        <CookieConsentBanner />
        <VersionUpdateBanner />
      </BannersWrapper>
      {children}
    </TopBannersLayoutStyled>
  );
};
